<ng-template #tabFlag let-active="active" let-count="count">
  <span
    class="flex items-center justify-center min-w-[28px] h-7 px-2 rounded-full text-sm transition-colors"
    [class.bg-lFlagIcon]="active"
    [class.text-black]="active"
    [class.bg-lSecondary]="!active"
    [class.text-lBlack]="!active"
    [class.group-hover:bg-lWhite]="!active"
    [class.group-hover:text-lBlack]="!active"
  >
    {{ count }}
  </span>
</ng-template>

<div class="flex gap-4 mt-6 mb-8" role="tablist">
  @for (pill of pills; track pill.value) {
    <div>
      <button
        role="tab"
        [attr.aria-selected]="activeTab === pill.value"
        (click)="selectTab(pill.value)"
        [class.bg-lWhite]="activeTab === pill.value"
        [class.bg-transparent]="activeTab !== pill.value"
        [class.text-lBlack]="activeTab === pill.value"
        [class.text-lSecondary]="activeTab !== pill.value"
        [ngClass]="{ 'hover:text-lWhite': activeTab !== pill.value }"
        class="group flex items-center gap-2 px-6 py-3 rounded-full text-sm transition-all"
      >
        <span>{{ pill.label }}</span>
        <ng-container
          *ngTemplateOutlet="tabFlag; context: { active: activeTab === pill.value, count: pill.count }"
        ></ng-container>
      </button>
    </div>
  }
</div>
